import React from 'react';
import styled from 'styled-components';
import { Slider as ReactSlider, Rail, Handles, Tracks } from 'react-compound-slider';

interface ISlider {
  'data-qa'?: string;
  range: [number, number];
  handleSlideEnd: (updatedValues: [number, number]) => void;
  handleSlideStart?: () => void;
  handleUpdate: (updatedValues: [number, number]) => void;
  step: number;
  values: [number, number];
}

export const Slider = ({
  'data-qa': dataQa,
  range,
  handleSlideEnd,
  handleSlideStart,
  handleUpdate,
  step,
  values,
}: ISlider) => {
  return (
    <Slider.Wrapper data-qa={dataQa || 'filter_slider'}>
      <ReactSlider
        mode={2} // mode 2 keeps the sliders from crossing
        step={step}
        domain={range}
        onUpdate={handleUpdate}
        onSlideEnd={handleSlideEnd}
        onSlideStart={handleSlideStart}
        values={Array.isArray(values) ? values : []}
      >
        <Rail>
          {({ getRailProps }) => (
            <div
              className="sliderRail"
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...getRailProps()}
            />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div>
              {handles.map((handle) => (
                <div
                  key={handle.id}
                  className="sliderHandle"
                  style={{ left: `${handle.percent}%` }}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...getHandleProps(handle.id)}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks>
          {({ tracks, getTrackProps }) => (
            <div>
              {tracks.map(({ id, source, target }) => (
                <div
                  key={id}
                  className="sliderTrack"
                  style={{
                    width: `${target.percent - source.percent}%`,
                    left: `${source.percent}%`,
                  }}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...getTrackProps()}
                />
              ))}
            </div>
          )}
        </Tracks>
      </ReactSlider>
    </Slider.Wrapper>
  );
};

Slider.Wrapper = styled.div`
  position: relative;
  margin-top: 12px;

  .sliderRail {
    position: relative;
    background-color: ${({ theme }) => theme.navigation.loaderColor};
    width: 100%;
    height: 1px;
    pointer-events: none;
  }

  .sliderHandle {
    border: 1px solid ${({ theme }) => theme.navigation.borderColor};
    background-color: ${({ theme }) => theme.navigation.backgroundColor};
    width: 16px;
    height: 16px;
    position: absolute;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }

  .sliderTrack {
    position: absolute;
    transform: translate(0%, -50%);
    height: 100%;
    cursor: pointer;
  }
`;
